import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import AIRecommendationCard from "@/components/AIRecommendationCard";
import { toast } from "sonner";

const STATUSES = ["all", "pending", "approved", "rejected", "executed", "expired", "failed"];

export default function Signals() {
  const [filter, setFilter] = useState("all");
  const [signals, setSignals] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const params = filter === "all" ? {} : { status_filter: filter };
    const r = await api.get("/signals", { params });
    setSignals(r.data);
  };

  useEffect(() => { load(); }, [filter]);

  const onApprove = async (s) => {
    setBusy(true);
    try {
      const r = await api.post(`/signals/${s.id}/approve`);
      if (r.data.filled) toast.success(`Filled ${s.symbol}`); else toast.error("Blocked by risk");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };

  const onReject = async (s) => {
    setBusy(true);
    try {
      await api.post(`/signals/${s.id}/reject`);
      toast.success(`${s.symbol} rejected`);
      load();
    } catch (e) { toast.error("Failed"); } finally { setBusy(false); }
  };

  return (
    <Layout>
      <div className="p-6">
        <header className="mb-6 flex items-center justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl font-medium tracking-tight">AI Signal Stream</h1>
            <p className="text-xs text-[#8B95A5] mt-1">Every recommendation the AI agent has generated for your account.</p>
          </div>
          <div className="flex flex-wrap gap-1" data-testid="signals-filter">
            {STATUSES.map(s => (
              <button
                key={s}
                onClick={() => setFilter(s)}
                className={`tag ${filter === s ? "ai" : ""}`}
                data-testid={`filter-${s}`}
              >
                {s}
              </button>
            ))}
          </div>
        </header>

        {signals.length === 0 ? (
          <div className="panel p-8 text-center text-xs text-[#4B5563]">No signals matching this filter.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="signals-list">
            {signals.map(s => (
              <AIRecommendationCard key={s.id} signal={s} busy={busy} onApprove={onApprove} onReject={onReject} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
